import styles from './style.postcss';
import cellStyles from 'components/SimpleTable/style.postcss';
import React, { PureComponent } from 'react';
import is from 'is_js';
import Panel from './Panel';
import { mediaQuery, PageCard, HorizontalScroll, Icon, testClass } from 'omni-common-ui';
import classnames from 'classnames';
import SimpleTable from 'components/SimpleTable';
import PropTypes from 'prop-types';

class TableWithExpandablePanel extends PureComponent {
  constructor(props) {
    super(props);
    this._onScrollReady = this._onScrollReady.bind(this);
    this._toggleExpand = this._toggleExpand.bind(this);
    this._onAnimationEnded = this._onAnimationEnded.bind(this);
    this.state = { expanded: mediaQuery('(min-width: 1024px)').matches };
    this._setUpData(props);
  }

  componentDidMount() {
    this._animatePanel();
  }

  componentWillUpdate(props) {
    this._setUpData(props);
  }

  componentDidUpdate() {
    this._animatePanel();

    const panelTrs = this._panel.querySelectorAll('tbody tr');
    const tableTrs = this._table.querySelectorAll('tbody tr');
    for (let index = 0; index < panelTrs.length; index++) {
      panelTrs[index].style.height = `${tableTrs[index].offsetHeight}px`;
    }
  }

  _setUpData(props) {
    const children = React.Children.toArray(props.children);
    const panel = children.find((child) => child.type === Panel);
    const panelChildren = panel.props.children;
    this._panelClassName = panel.props.className;
    this._mainTableHeader = children.find((child) => child.type === SimpleTable.Header);
    this._mainTableBody = children.find((child) => child.type === SimpleTable.Body);
    this._panelTableHeader = panelChildren.find((child) => child.type === SimpleTable.Header);
    this._panelTableBody = panelChildren.find((child) => child.type === SimpleTable.Body);
    this._setUpPanelWidth();
  }

  _setUpPanelWidth() {
    if (this._expandedPanelSize) return;
    if (this._panel) {
      const ths = this._panel.querySelectorAll('.test-table-row th');
      const cells = this._panel.querySelectorAll('.test-table-cell');
      // ensure that we calculate the right width
      if (ths && cells && cells.length > ths.length) {
        this._expandedPanelSize = this._panel.querySelector('table').offsetWidth;
      }
    }
  }

  _onScrollReady(scroll) {
    this._scroll = scroll;
    const smallScreenQuery = mediaQuery('(max-width: 639px)');
    const activeDiv = this._table.querySelector(`.${cellStyles.__highlighted}`);
    const animLeftOffset = 50;
    const animLeftOffsetLg = 100;
    const animDurationMs = 300;
    if (activeDiv && activeDiv.offsetLeft > 0) {
      if (smallScreenQuery.matches) {  // mobile?
        // snap to left for mobile
        scroll.scrollToElement(activeDiv, 0, - animLeftOffset);
        scroll.scrollBy(- animLeftOffset, 0, animDurationMs);  // flush with "panel"
      } else {
        // centre the element on-screen
        scroll.scrollToElement(activeDiv, 0, true, true);  // centre
        scroll.scrollBy(animLeftOffsetLg, 0, 0);  // back
        scroll.scrollBy(- animLeftOffsetLg, 0, animDurationMs);  // forth
      }
    }
  }

  _toggleExpand() {
    const afterStateChange = is.function(this.props.onExpandedChange) &&
        (() => this.props.onExpandedChange(this.state.expanded));
    this.setState((state) => ({ expanded: ! state.expanded }), afterStateChange);
  }

  _animatePanel() {
    this._panel.addEventListener('transitionend', this._onAnimationEnded, { once: true });
    if (this.state.expanded) {
      this._panel.style.width = `${this._expandedPanelSize}px`;
      this._panel.style.flexBasis = `${this._expandedPanelSize}px`;
    } else {
      this._panel.style.width = '';
      this._panel.style.flexBasis = '';
    }
  }

  _onAnimationEnded() {
    this._scroll && this._scroll.refresh();
  }

  render() {
    const panelClasses = classnames(styles.TableWithExpandablePanel_panel,
        testClass('panel'),
        { [styles.__expanded]: this.state.expanded },
        this._panelClassName);

    return <PageCard className={classnames(styles.TableWithExpandablePanel, testClass('table-with-expandable-panel'))}>
      <div className={panelClasses} onClick={this._toggleExpand} ref={(c) => { this._panel = c; }}>
        <div className={styles.TableWithExpandablePanel_panel_wrap}>
          <Icon id="chevron-small-right"
              className={styles.TableWithExpandablePanel_panel_icon} />
          <SimpleTable stripeRows={this.props.stripeRows}
              rows={this.props.rows}
              onlyRowDivider
              textAlign="left">
            <SimpleTable.Header>{this._panelTableHeader.props.children}</SimpleTable.Header>
            <SimpleTable.Body>{this._panelTableBody.props.children}</SimpleTable.Body>
          </SimpleTable>
        </div>
      </div>
      <div className={classnames(styles.TableWithExpandablePanel_tableContainer, testClass('body'))} ref={(c) => { this._table = c; }}>
        <HorizontalScroll onScrollReady={this._onScrollReady}>
          <SimpleTable highlightedColumns={this.props.highlightedColumns}
              stripeRows={this.props.stripeRows}
              tableRef={(c) => { this._table = c; }}
              rows={this.props.rows}
              isFullHeightToPanel={this.props.isFullHeightToPanel}
              onlyRowDivider={this.props.onlyRowDivider}>
            <SimpleTable.Header>{this._mainTableHeader.props.children}</SimpleTable.Header>
            <SimpleTable.Body>{this._mainTableBody.props.children}</SimpleTable.Body>
          </SimpleTable>
        </HorizontalScroll>
      </div>
    </PageCard>;
  }
}

TableWithExpandablePanel.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.any),
  children: PropTypes.node,
  stripeRows: PropTypes.arrayOf(PropTypes.number),
  highlightedColumns: PropTypes.arrayOf(PropTypes.number),
  onExpandedChange: PropTypes.func,
  onlyRowDivider: PropTypes.bool,
  isFullHeightToPanel: PropTypes.bool,
};

export default TableWithExpandablePanel;



// WEBPACK FOOTER //
// ./components/TableWithExpandablePanel/component.jsx